import { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useTrackWebContext from "../../../hooks/useTrackWebContext.jsx";
import InputSpinner from "../../common/InputSpinner.jsx";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { getColaboradores } from "../../../utilities/services.js";
import HeaderList from "./HeaderList.jsx";
import Collaborators from "./Collaborators.jsx";
import SuccessModal from "../Modal/SuccessModal.jsx";
import { registerCollaborator } from "../../../utilities/servicesTrackWeb.js";


const RegisterCollaborator = () => {
  const {
    token,
    isLogin,
  } = useTrackWebContext();
  const [dni, setDni] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
 const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingFetch, setLoadingFetch] = useState(false);

  const [error, setError] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const fetchColaboradores = useCallback(async () => {
    try {
      const data = await getColaboradores(token); 
      console.log("DATAAA", data)
      setColaboradores(data.data);
      setLoadingFetch(false)
    } catch (err) {
      console.error("Error cargando colaboradores", err);
    }
  }, [token]);

  useEffect(() => {
    setLoadingFetch(true)
    fetchColaboradores();
  }, [fetchColaboradores]);



const handleSubmit = async (e) => {
  e.preventDefault();
  setLoadingSubmit(true);
  setError("");

  if (password.length < 6) {
    setPasswordError("La contraseña debe tener al menos 6 caracteres");
    setLoadingSubmit(false);
    return;
  }
  setPasswordError("");

  try {
    await registerCollaborator({
      dni,
      name,
      email,
      pwd: password,
      token,
    });
    setAddModal(true);
    fetchColaboradores();
    cleanUpActivity();
  } catch (err) {
    setError("No se pudo registrar el colaborador");
  } finally {
    setLoadingSubmit(false);
  }
};

  


  const cleanUpActivity = () => {
    setDni("");
    setName("");
    setEmail("");
    setPassword("");
  };

  return (
    <div className="mr-4 mb-10 pb-2 lg:ml-[50px]
           xl:ml-[50px]">
      {!isLogin && <Navigate to="/login" replace={true} />}
      <form
        className="
          min-h-[75%] rounded-[3px] shadow-md shrink-0 static block bg-white
          md:w-full md:mx-0 md:mt-0 md:px-[30px] md:pt-[25px] md:pb-[16px]
          lg:w-[600px] 
          xl:w-[830px]"
        onSubmit={handleSubmit}
      >
        <div className="mb-2 md:mb-4">
          <h2 className="font-bold text-2xl text-clvblue">Añadir Colaborador</h2>
          <p className="font-normal text-base leading-tight text-gray-900">
            Ingresá los siguientes datos para registrar un nuevo colaborador
          </p>
        </div>
        <div className="flex flex-col mt-8">
          <label
            className="  block font-bold text-xl"
          >
            Datos del colaborador
          </label>
          <input
            id="name"
            type="text"
            // TODO: Sacar las flechitas del type number.
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue "
            placeholder="Nombre y apellido"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            id="dni"
            type="text"
            // TODO: Sacar las flechitas del type number.
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue "
            placeholder="DNI"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
          />
          <input
            id="mail"
            type="text"
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue "
            placeholder="Dirección de correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="flex">
            <input
            id="password"
            type={showPassword ? "text" : "password"}
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl  focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue "
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-4 flex items-center text-gray-500"
          >
          {showPassword ? (
            <AiFillEyeInvisible className="w-6 h-6" />
          ) : (
            <AiFillEye className="w-6 h-6" />
          )}
          </button>

          </div>
          {passwordError && (
            <p className="text-red-500 text-sm mt-1 ml-2">{passwordError}</p>
          )}
          {error && (
            <p className="text-red-500 text-sm mt-1 ml-2">{error}</p>
          )}
        </div>
        

        <div className="my-4 flex flex-col justify-between">
          
          
          
        </div>
        

        {loadingSubmit && <InputSpinner />}

        {!loadingSubmit && (
          <div className="xl:w-3/4 my-4 md:mb-4 flex justify-center">
            <input
              type="submit"
              value="Añadir colaborador"
              className={`${
                !dni || !name || !email || !password
                  ? "disabled:bg-gray-300 disabled:cursor-not-allowed"
                  : ""
              } rounded-full w-full px-4 py-2 text-xl font-bold  bg-clvblue text-white hover:cursor-pointer hover:bg-clvHoverBlue`}
              disabled={!dni || !name || !email || !password}
            />
          </div>
        )}
     


      {addModal && (
                <SuccessModal
                  message="Colaborador añadido"
                  cleanUpActivity={cleanUpActivity}
                  onClose={() => setAddModal(false)}
                />
              )}
      </form>
      <hr className="my-4 border-t border-gray-300" />
      <div className="min-h-[75%] rounded-[3px] shadow-md shrink-0 static block bg-white md:w-full md:mx-0 md:mt-0 md:px-[30px] md:pt-[25px] md:pb-[16px]
          lg:w-[600px] 
          xl:w-[830px]">
<h2 className="font-bold text-2xl text-clvblue mb-2">Historial de colaboradores añadidos</h2>
      <div className=" overflow-x-auto">
        <table className="w-full text-sm">
          <HeaderList />
          {loadingFetch && (
            <tr>
              <td colSpan="100%" className="py-6">
                <div className="flex justify-center items-center">
                  <InputSpinner />
                </div>
              </td>
            </tr>
          )}
          {colaboradores?.map((item, index) => (
            <Collaborators
              key={index}
              update={fetchColaboradores}
              {...item}
            />
          ))}
        </table>
      </div>
      </div>
      
    </div>
  );
};
export default RegisterCollaborator;
